// Document Type-specific validation - Uses generic validation utility
import { createValidation } from '../../../utils/validation';

/**
 * Document Type-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing document type module code
 */
export const createDocumentTypeValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return the same interface but with document type-specific method names
  return {
    schema: validation.schema,
    validateDocumentTypeData: validation.validateData,
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createDocumentTypeValidation;
